import { render, staticRenderFns } from "./organizaciona-jedinica.editor.vue?vue&type=template&id=838ded92&"
import script from "./organizaciona-jedinica.editor.vue?vue&type=script&lang=ts&"
export * from "./organizaciona-jedinica.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports